export default __webpack_public_path__ + "static/media/evee-loader.a4706ad6.svg";